module.exports = __webpack_public_path__ + "static/media/okc_logo.5f6e1f33.svg";